import { Cancel as CancelIcon } from '@mui/icons-material'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tab,
  Tabs,
} from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import FlinksCalculatorTab from './FlinksCalculatorTab'
import YtdCalculatorTab from './YtdCalculatorTab'

interface Props {
  open: boolean
  onClose: () => void
  provinceIso: string | null
}

const IncomeCalculatorDialog = ({ open, onClose, provinceIso }: Props) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState(0)

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('incomeCalculator.title')}</DialogTitle>
      <DialogContent>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label={t('incomeCalculator.ytdTab')} />
          <Tab label={t('incomeCalculator.flinksTab')} />
        </Tabs>
        <Box sx={{ display: activeTab === 0 ? 'block' : 'none' }}>
          <YtdCalculatorTab />
        </Box>
        <Box sx={{ display: activeTab === 1 ? 'block' : 'none' }}>
          <FlinksCalculatorTab provinceIso={provinceIso} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="warning" startIcon={<CancelIcon />} onClick={onClose}>
          {t('common.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default IncomeCalculatorDialog
